class DataProcessor {
    constructor(type) {
        this.type = type;
    }
    async init() {
        try {
            this.processor = await import(`@/components/fileProcessors/${this.type}.js`);
        }
        catch (e) {
            console.log('could not initialize ' + this.type, e);
            throw e;
        }
    }
    async getColumnNames(data, errorFunction) {
        if(!this.processor.getColumnNames) {
            throw new Error('this.processor.getColumnNames not implemented');
        }
        console.log('using', this.type)
        const colnames = await this.processor.getColumnNames(data).catch(e => {
            errorFunction(e);
            //throw e;
        });
        console.log('received colnames', colnames);
        return colnames;
    }
    async getData(data) {
        if(!this.processor.getData) {
            throw new Error('this.processor.getData not implemented');
        }
        return await this.processor.getData(data);
    }
    validateColumns(data) {
        if(this.processor.validateColumns) {
            return this.processor.validateColumns(data);
        }
        return true;
    }
}

export default DataProcessor;